export const CODE_POSTAL_MAYOTTE = '976' as const
export const CODES_POSTAUX_DROM = ['971', '972', '973', '974'] as const
export const CODES_POSTAUX_UNIQUE = ['97133', '97150', CODE_POSTAL_MAYOTTE, '975'] as const

export const DRF_TAUX_HOR = parseFloat(import.meta.env.VITE_DRF_TAUX_HOR)
export const SMIC_HOR_BRUTE = parseFloat(import.meta.env.VITE_DEMANDE_SMIC_HOR_BRUTE)
export const SMIC_HOR_BRUTE_MAYOTTE = parseFloat(import.meta.env.VITE_DEMANDE_SMIC_HOR_BRUTE_MAYOTTE)

export const DEMANDE_CODE_PREFIX = import.meta.env.VITE_DEMANDE_CODE_PREFIX

export const SOUS_DISPOSITIFS_EXCLUES = Object.freeze(
  `${import.meta.env.VITE_SOUS_DISPOSITIFS_EXCLUS}`
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s)
)
